export const AuthConstant = {
  AUTH_TOKEN: "auth-token",
  LOGIN_USER_NAME: "login-username",
};

export const errorConstants = {
  GENERIC: "An unexpected error has occurred",
  TIMEOUT: "Connection timed out. Please try again later.",
  CREDENTIALS: "Invalid Credentials. Try again.",
};

export const RegularExpressions = {
  // NUMBER_WITH_TWO_DECIMAL: /^(\d{1,3})?([.]?\d{1,2})?$/,
  NUMBER_WITH_TWO_DECIMAL: /^\d+(\.\d{1,2})?$/,
  OFFSET_FORMAT: /^(\d+D\s*)?(\d+H\s*)?(\d+M)?$/,
};

export const HtmlHelpers = {
  SINGLE_SPACE: "\u00A0",
  DOUBLE_SPACE: "\u00A0\u00A0",
  TRIPLE_SPACE: "\u00A0\u00A0\u00A0",
  FOUR_TIMES_SPACE: "\u00A0\u00A0\u00A0\u00A0",
};

export const Constants = {
  DEFAULT_OFFSET_VALUE: `D ${HtmlHelpers.FOUR_TIMES_SPACE}H`,
};

export const times = [
  {
    key: "06:00",
    value: "06:00:00",
  },
  {
    key: "08:00",
    value: "08:00:00",
  },
  {
    key: "10:00",
    value: "10:00:00",
  },
  {
    key: "12:00",
    value: "12:00:00",
  },
  {
    key: "14:00",
    value: "14:00:00",
  },
   {
    key: "16:00",
    value: "16:00:00",
  },
  {
    key: "18:00",
    value: "18:00:00",
  },
  {
    key: "20:00",
    value: "20:00:00",
  },
  {
    key: "22:00",
    value: "22:00:00",
  },
  {
    key: "24:00",
    value: "23:59:59",
  },
];

export const dialogStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "50%",
  maxWidth: "50%",
  bgcolor: "background.paper",
  boxShadow: 24,
  borderRadius: 1,
  px: "4.375rem",
  py: "1.875rem",
  backgroundColor: "#F5F5F5",
  "& .MuiOutlinedInput-root": {
    borderRadius: "4px",
    margin: "0px 0px",
    padding: "0px 0px",
    // height: "45px",
    "&.Mui-focused fieldset": {
      borderColor: "#000000",
      borderWidth: "1px",
    },
    "&:hover fieldset": {
      borderColor: "#000000",
      borderWidth: "1px",
    },
    "&.Mui-disabled": {
      backgroundColor: "#F5F5F5",
      "& fieldset": {
        borderColor: "#B1B1B1",
      },
    },
  },
  "& .MuiInputLabel-root.Mui-focused": {
    color: "#000000",
  },
  "& .MuiOutlinedInput-notchedOutline": {
    borderColor: "#000000",
    borderWidth: "1px",
  },
  "& .MuiTableCell-root": {
    padding: "10px",
  },
};
